module.exports = __webpack_public_path__ + "img/003-astronaut.e01268b0.png";